import { Component, OnInit } from '@angular/core';
import { Slide, SlideItem } from '../models/Slide';
import { SlideService } from '../services/slide.service';

declare var $: any;

@Component({
  selector: 'app-mono',
  templateUrl: './mono.component.html',
  styleUrls: ['./mono.component.css']
})
export class MonoComponent implements OnInit {

  slides: Slide;
  slideItems: SlideItem[];
  Zhyper: string ="hhhhhhhh"
  view: boolean = true;

  constructor(
    private slideService: SlideService
  ) { }

  ngOnInit(): void {
alert();
  }

}
